import { UsersAppWebComponent } from './component/UsersAppWebComponent';
import { WEB_COMPONENT_USERS_APP } from '../../webcomponents.constants';

export { UsersAppWebComponent };

window.customElements.define(WEB_COMPONENT_USERS_APP, UsersAppWebComponent);
